namespace RioERP.Reports {
    export interface ShippingReportForm {
        OrderId: Serenity.LookupEditor;
        OrderNumber: Serenity.StringEditor;
        OrderDate: Serenity.DateEditor;
        CustomerName: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        CustomerEmail2: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        CustomerMobile2: Serenity.StringEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingPincode: Serenity.IntegerEditor;
        ShippingDate: Serenity.DateEditor;
        SourceType: Serenity.EnumEditor;
        Status: Serenity.EnumEditor;
        ShippingProviderName: Serenity.StringEditor;
        TrackingId: Serenity.StringEditor;
        TrackingUrl: Serenity.StringEditor;
        ShippingProviderId: Serenity.LookupEditor;
    }

    export class ShippingReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.ShippingReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ShippingReportForm.init)  {
                ShippingReportForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(ShippingReportForm, [
                    'OrderId', w0,
                    'OrderNumber', w1,
                    'OrderDate', w2,
                    'CustomerName', w1,
                    'CustomerEmail1', w1,
                    'CustomerEmail2', w1,
                    'CustomerMobile1', w1,
                    'CustomerMobile2', w1,
                    'ShippingAddress1', w1,
                    'ShippingAddress2', w1,
                    'ShippingCity', w1,
                    'ShippingPincode', w3,
                    'ShippingDate', w2,
                    'SourceType', w4,
                    'Status', w4,
                    'ShippingProviderName', w1,
                    'TrackingId', w1,
                    'TrackingUrl', w1,
                    'ShippingProviderId', w0
                ]);
            }
        }
    }
}
